import { inject as vueInject, Ref, App, ref, ComputedRef, computed } from 'vue';
import { CurrentUserApiService as CurrentAdminUserApiService } from '@/api/admin/resources/current_user';
import { CurretUser, CurrentAdminUser, UserRole, AdminUserRole } from '@/api/openapi';
import { CurrentUserApiService as CurrentAppUserApiService } from '@/api/user/resources/current_user';

const INJECTION_KEY = Symbol();

export const useCurrentUserProvider = () => {
  const fetchCurrentAppUser = async () => {
    const api = new CurrentAppUserApiService();
    const { data: { currentUser } } = await api.getCurrentUser({});
    return currentUser;
  };
  const fetchCurrentAdminUser = async () => {
    const api = new CurrentAdminUserApiService();
    const { data: { currentUser } } = await api.getCurrentUser({});
    return currentUser;
  };

  const currentUser = ref<CurretUser | null>(null);
  const currentAdminUser = ref<CurrentAdminUser | null>(null);

  const isBalesBPO = computed(() => currentUser.value?.tenantType === 'bales_bpo');

  const authorize = (allowedRoles: (UserRole | AdminUserRole)[]) => {
    return allowedRoles.includes(currentUser.value?.role || currentAdminUser.value?.role);
  };

  const refetchCurrentUser = async () => {
    currentUser.value = await fetchCurrentAppUser();
  };

  const refetchCurrentAdminUser = async () => {
    currentAdminUser.value = await fetchCurrentAdminUser();
  };

  const provide = (app: App) => {
    app.provide(INJECTION_KEY, {
      currentUser,
      currentAdminUser,
      refetchCurrentUser,
      refetchCurrentAdminUser,
      authorize,
      isBalesBPO,
    });
  };

  const inject = () => {
    return vueInject<{
      currentUser: Ref<CurretUser | null>,
      currentAdminUser: Ref<CurrentAdminUser | null>,
      refetchCurrentUser: () => Promise<void>,
      refetchCurrentAdminUser: () => Promise<void>,
      authorize: (allowedRoles: (UserRole | AdminUserRole)[]) => boolean,
      isBalesBPO: ComputedRef<boolean>
    }>(INJECTION_KEY);
  };

  return {
    provide,
    inject,
  };
};
